/**
 * @description 检索中心
 * @author cjs1992
 * @date 2020-09-22 10:41:03
 */
import { request } from "@/api/axios.js";
/**
 * @name getDeptByCode
 * @description 根据部门code获取部门详情
 * @param {
 *  deptCode
 * }
 * @return {}
 * @author cjs1992
 * @date 2020-09-22 10:41:38
 */
export function getDeptByCode(data = {}, config = {}) {
  return request({
    method: "get",
    url: "/portal-ywtb/web/deptGuideline/getDeptByCode",
    params: data
  });
}
/**
 * @name getStatisticConfig
 * @description 获取是否展示服务成效统计
 * @param {
 *  deptCode
 * }
 * @return {}
 * @author cjs1992
 * @date 2020-09-22 16:37:57
 */
export function getStatisticConfig(data = {}, config = {}) {
  return request({
    method: "post",
    url: "/portal-ywtb/web/deptConfig/getStatisticConfig",
    params: data
  });
}
/**
 * @name /web/deptGuideline/getAllSceneGuideline
 * @description 获取部门的事项主题和排序
 * @param {
 *  deptCode
 * }
 * @return {}
 * @author cjs1992
 * @date 2020-09-29 10:51:35
 */
export function getAllSceneGuideline(data = {}, config = {}) {
  return request({
    method: "get",
    url: "/portal-ywtb/web/deptGuideline/getAllSceneGuideline",
    params: data
  });
}
/**
 * @name queryDeptTemplateInfo
 * @description 查询模板配置
 * @param {
 *  deptCode
 * }
 * @return {}
 * @author cjs1992
 * @date 2020-10-22 14:31:40
 */
export function webQueryDeptTemplateInfo(data = {}, config = {}) {
  return request({
    method: "post",
    url: `/portal-ywtb/web/deptTemplate/webQueryDeptTemplateInfo`,
    data,
    ...config
  });
}
/**
 * @name findDepartmentGuidelineSequenceList
 * @description 根据部门code获取事项
 * @param {}
 * @return {}
 * @author cjs1992
 * @date 2020-10-22 17:59:06
 */
export function findDepartmentGuidelineSequenceList(data = {}, config = {}) {
  return request({
    method: "post",
    url: `/portal-ywtb/web/deptGuideline/queryDepartmentGuidelineSequenceList`,
    data,
    ...config
  });
}



// WEBPACK FOOTER //
// ./src/api/deptHome.js